export default __webpack_public_path__ + "assets/dda21a8f3f32f49cfc8696cc64ed43ad.ttf";